import { GridWrapper } from './styles';

export default GridWrapper;
